import { activeProjectId, getEnvPillConfig } from './ownerEnv'

export const OwnerEnvBadge = ({ projectId = activeProjectId() }: { projectId?: string }) => {
  const config = getEnvPillConfig(projectId)

  return (
    <div
      className={`ownerEnvBadge ${config.className}`}
      title={config.tooltip}
      aria-label={`Current environment: ${config.label}`}
    >
      <span className="ownerEnvBadgeDot" aria-hidden="true" />
      <span>{config.label}</span>
    </div>
  )
}
